import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

var _publishButtonColorMa;

import { createStyles } from '@material-ui/core';
import { PublicationStatus } from '@uno/common-cms';
import { borderRadius, colorUsage, getSpacing } from 'stylesheet';
var publishButtonColorMap = (_publishButtonColorMa = {}, _defineProperty(_publishButtonColorMa, PublicationStatus.OFFLINE, {
  main: colorUsage.status.icon.color.offline,
  light: colorUsage.status.color.offline
}), _defineProperty(_publishButtonColorMa, PublicationStatus.ONLINE, {
  main: colorUsage.status.icon.color.online,
  light: colorUsage.status.color.online
}), _defineProperty(_publishButtonColorMa, PublicationStatus.SCHEDULED, {
  main: colorUsage.status.icon.color.scheduled,
  light: colorUsage.status.color.scheduled
}), _publishButtonColorMa);
var MuiPublishButtonOverrideGenerator = createStyles({
  root: {
    borderRadius: borderRadius.medium,
    color: function color(_ref) {
      var publicationStatus = _ref.publicationStatus;
      return publishButtonColorMap[publicationStatus].main;
    },
    borderColor: function borderColor(_ref2) {
      var publicationStatus = _ref2.publicationStatus;
      return publishButtonColorMap[publicationStatus].main;
    },
    backgroundColor: function backgroundColor(_ref3) {
      var publicationStatus = _ref3.publicationStatus;
      return publishButtonColorMap[publicationStatus].light;
    },
    textTransform: 'none',
    margin: getSpacing(1)
  }
});
export { MuiPublishButtonOverrideGenerator };